// import React, { useState } from 'react';
// import './SearchPopup.css';

// const SearchPopup = ({ onClose }) => {
//   const [firstName, setFirstName] = useState('');
//   const [lastName, setLastName] = useState('');

//   const handleSearch = () => {
//     // Handle search logic here
//     console.log('Search:', { firstName, lastName });
//   };

//   return (
//     <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 2000 }}>
//       <div style={overlayStyle} onClick={onClose}></div>
//       <div style={popupStyle}>
//         <div style={popupContentStyle}>
//           <h2 id='search-title'>חיפוש דוקט </h2>
//           <h5 id='search-exp'>חפש לפי שם לקוח בעברית או באנגלית</h5>
//           <input
//             type="text"
//             placeholder="שם פרטי"
//             value={firstName}
//             onChange={(e) => setFirstName(e.target.value)}
//             style={inputStyle}
//           />
//           <input
//             type="text"
//             placeholder="שם משפחה"
//             value={lastName}
//             onChange={(e) => setLastName(e.target.value)}
//             style={inputStyle}
//           />
//           <button onClick={handleSearch} style={buttonStyle}>
//             חפש
//           </button>
//           <button onClick={onClose} style={buttonStyle}>
//             סגור
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// // Styles
// const popupStyle = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   transform: 'translate(-50%, -50%)',
//   zIndex: 3000,
// };

// const popupContentStyle = {
//   background: 'white',
//   padding: '20px',
//   borderRadius: '8px',
//   boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
// };

// const overlayStyle = {
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   width: '100%',
//   height: '100%',
//   background: 'rgba(0, 0, 0, 0.3)',
// };

// const inputStyle = {
//   display: 'block',
//   margin: '10px 0',
//   padding: '8px',
//   width: '100%',
// };

// const buttonStyle = {
//   margin: '10px 5px',
//   padding: '8px 12px',
// };

// export default SearchPopup;



import React, { useState } from 'react';
import './SearchPopup.css';
import { fetchPostDocket } from '../../../faetures/fetch';

const SearchPopup = ({ onClose, setNumDocket }) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [docketsIdsArr, setDocketsIdsArr] = useState([]);
    const [searchPerformed, setSearchPerformed] = useState(false); 

    
    const handleSearch = () => {
        console.log('Search:', { firstName, lastName });
        setSearchPerformed(true)
        const data = [firstName, lastName];
        fetchPostDocket('search-by-name', data)
        .then(res=>{
            console.log(res);
            if(res.status == 0)
                setDocketsIdsArr([]);
            else if (res.status == 1)
                setDocketsIdsArr(res.docket_ids);
        })
        .catch(err=>{console.log(err)})
    };

    const handleDocketClick = (id) => {
        setNumDocket(id);
    };


    return (
        <div className="popup-container">
            <div className="popup-overlay" onClick={onClose}></div>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
                <h2 id='search-title'>חיפוש דוקט</h2>
                <h4 id='search-exp'>חפש לפי שם לקוח בעברית או באנגלית</h4>
                <input
                    type="text"
                    placeholder="שם פרטי"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    className="popup-input"
                />
                <input
                    type="text"
                    placeholder="שם משפחה"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    className="popup-input"
                />
                <button onClick={handleSearch} className="popup-button">
                    חפש
                </button>
                <button onClick={onClose} className="popup-button">
                    סגור
                </button>
                { searchPerformed && <div className="docket-buttons">
                    {docketsIdsArr.length === 0 ? (
                        <p>משתמש לא קיים</p>
                        
                    ) : (
                        docketsIdsArr.map(id => (
                            <button
                                key={id}
                                className="docket-button"
                                onClick={() => handleDocketClick(id)}
                            >
                                {id}
                            </button>
                        ))
                    )}
                </div>}

            </div>
        </div>
    );
};

export default SearchPopup;

